import axios from 'axios';

const getProdutosPage = params => axios.get('/produtos/page', {
  params,
});

export default {
  getProdutosPage,
};
